import { render, staticRenderFns } from "./AssignCollaboratorModal.vue?vue&type=template&id=e9b853fc&scoped=true&"
import script from "./AssignCollaboratorModal.vue?vue&type=script&lang=js&"
export * from "./AssignCollaboratorModal.vue?vue&type=script&lang=js&"
import style0 from "./AssignCollaboratorModal.vue?vue&type=style&index=0&id=e9b853fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9b853fc",
  null
  
)

export default component.exports